import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { finalize } from "rxjs/operators";
import { Plan } from "src/app/shared/model/security/plan.model";
import { Msg } from "src/app/utilerias/mensajes/Msg";
import { PlanesService } from "./planes.service";

/**
 * Planes de MI empresa: qué módulos tiene contratados, cuántas licencias,
 * cuántas ocupadas y hasta cuándo. Sólo lectura.
 *
 * POR QUÉ NO SE EDITA AQUÍ
 * Los planes los vende Solser: un cliente no se amplía el cupo ni se renueva
 * la vigencia a sí mismo. Esta pantalla existe para que quien administra al
 * cliente entienda por qué un módulo dejó de repartirse («cupo lleno») o
 * dejó de verse («vencido») sin tener que preguntar.
 *
 * Las «licencias ocupadas» son el mismo número que usa Gestión de empleados
 * para dejar de ofrecer un módulo y el que frena la asignación de modalidades
 * en Asistencia: quien tiene un perfil vigente del módulo y, en Asistencia,
 * también quien tiene modalidad asignada.
 */
@Component({
  selector: "app-planes",
  standalone: true,
  templateUrl: "./planes.component.html",
  styleUrls: ["./planes.component.css"],
  imports: [CommonModule, MatButtonModule],
})
export class PlanesComponent implements OnInit {
  planes: Plan[] = [];
  loading = false;

  constructor(
    private planesService: PlanesService,
    private msg: Msg,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    queueMicrotask(() => {
      this.consultar();
      this.cdr.detectChanges();
    });
  }

  consultar(): void {
    this.loading = true;
    this.cdr.detectChanges();

    this.planesService
      .consultarPlanes()
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: (respuesta) => {
          this.planes = respuesta?.list ?? [];
          if (respuesta?.pMensaje && respuesta.pCodRetorno !== "00000") {
            this.msg.warningCall(respuesta.pMensaje, null, null);
          }
        },
        error: () => {
          this.planes = [];
          this.msg.errorCall("No se pudieron consultar los planes.", null, null);
        },
      });
  }

  get vigentes(): number {
    return this.planes.filter((plan) => plan.vigente).length;
  }

  /** El backend manda fecha y hora; aquí basta el día. */
  soloFecha(valor: string | null): string {
    if (!valor) {
      return "—";
    }
    return valor.length >= 10 ? valor.substring(0, 10) : valor;
  }

  etiquetaEstatus(plan: Plan): string {
    return plan.vigente ? "Vigente" : "Vencido";
  }

  /** La forma también dice el estado, no sólo el color. */
  claseEstatus(plan: Plan): string {
    return plan.vigente
      ? "table-page__status-badge table-page__status-badge--success"
      : "table-page__status-badge";
  }

  /** Cuántas licencias quedan; nunca negativo aunque el cupo se haya reducido. */
  disponibles(plan: Plan): number {
    return Math.max(0, (plan.cantidadUsuarios ?? 0) - (plan.usuariosAsignados ?? 0));
  }

  cupoLleno(plan: Plan): boolean {
    return plan.vigente && this.disponibles(plan) === 0;
  }

  esAsistencia(plan: Plan): boolean {
    return plan.sitio === "ASISTENCIA";
  }
}
